export class GlobalConstant {
	public static home: string = "Home"; 
	
	public static CREATE: string = "Create"; 
	public static UPDATE: string = "Update"; 
	public static RESET: string = "Reset"; 
	
	public static patternEmail: string = "[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}";
	
	public static KEY_TEST_SERIES_URL_ENC = "testSeriesUrl";
	
	public static KEY_URL_PARAM_VENDOR_UNIQUE_ID = "sid";
	public static KEY_LOCAL_STORAGE_LOGIN_TEMP_DATA = "loginTempData";
	public static KEY_LOCAL_STORAGE_VENDOR_UNIQUE_ID = "vUid";
	
	public static confirmDialogConfig = {
				    disableClose: false,
				    panelClass: 'text-color-top8',
				    hasBackdrop: true,
				    backdropClass: 'text-color-top8',
				    width: '400',
				    height: '',
				    minWidth: '',
				    minHeight: '',
				    maxWidth: '400',
				    maxHeight: '',
				    position: {
				      top: '',
				      bottom: '',
				      left: '',
				      right: ''
				    },
				    data: {
					  title: 'Confirm Action',
				      message: 'Are you sure ?'
				    }
				  };
}
